import script from "./PanelViewModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./PanelViewModal.vue?vue&type=script&setup=true&lang=ts"

import "./PanelViewModal.vue?vue&type=style&index=0&id=31712cd7&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-31712cd7"]])

export default __exports__